/**
 * Login Form Validation Schema
 *
 * Yup schema for validating login form inputs (email, password).
 * Used with React Hook Form resolvers for client-side validation.
 * Align with backend FluentValidation rules.
 */

import * as Yup from 'yup';

/**
 * Login validation schema
 * Validates email format and password requirements
 *
 * Rules:
 * - email: required, valid email format
 * - password: required, min 6 characters
 */
export const loginValidationSchema = Yup.object().shape({
  email: Yup.string()
    .strict(true)
    .typeError('Adres e-mail musi być tekstem')
    .required('Adres e-mail jest wymagany')
    .email('Podaj prawidłowy adres e-mail'),

  password: Yup.string()
    .strict(true)
    .typeError('Hasło musi być tekstem')
    .required('Hasło jest wymagane')
    .min(6, 'Hasło musi mieć co najmniej 6 znaków'),
});

/**
 * Infer TypeScript type from Yup schema
 * Ensures form values match validation schema
 */
export type LoginFormInputs = Yup.InferType<typeof loginValidationSchema>;
